import appAmbientBackground from './generated/barterment-app-ambient.webp';

export const lightBackground = appAmbientBackground;
export const darkBackground = appAmbientBackground;
